import { Label, makeStyles, tokens } from "@fluentui/react-components";
import { ProgressIndicatorStepIcon } from "./ProgressIndicatorStepIcon";

const buildStepStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        paddingTop: '40px'
    },
    progressDivider: {
        height: "30px",
        width: "2px",
        marginLeft: "12px",
    },
    iconContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "10px"
    }
});

export interface IProgressIndicatorStepProps {
    stepIndex: number;
    currentIndex: number;
    step: string;
}

export function ProgressIndicatorStep(props: Readonly<IProgressIndicatorStepProps>) {
    const { step, stepIndex, currentIndex } = props;

    const isComplete = stepIndex < currentIndex;
    const isCurrent = stepIndex === currentIndex;

    const styles = buildStepStyles();

    return (
        <div key={step}>
            <div className={styles.iconContainer}>
                <ProgressIndicatorStepIcon isComplete={isComplete} isCurrent={isCurrent} /> 
                <Label weight={isCurrent ? "semibold" : undefined} disabled={!isComplete && !isCurrent}>
                    {step.charAt(0).toUpperCase() + step.slice(1)}
                </Label>
            </div>
            {
                stepIndex < currentIndex && 
                <div className={styles.progressDivider} style={{backgroundColor: isComplete ? tokens.colorBrandForeground1 : tokens.colorNeutralForeground1}}></div>
            }
        </div>
    );
}